enum PlatformRole {
  Attendee = 'attendee',
  Administrator = 'administrator',
  Moderator = 'moderator',
  Presenter = 'presenter',
}

export default PlatformRole;
